const elementExists = document.querySelectorAll('.select-css-clearable');

Array.from(elementExists).forEach((selectWrap) => {
  if (typeof selectWrap !== 'undefined' && elementExists !== null) {
    const select = selectWrap.querySelector('select');
    if (select.value !== '') {
      selectWrap.classList.add('clear');
    }
    select.onchange = () => {
      if (select.value !== '') {
        selectWrap.classList.add('clear');
        select.form.submit();
      } else {
        selectWrap.classList.remove('clear');
        select.form.submit();
      }
    };
    const selectClear = selectWrap.querySelector('.select-clear');
    if (selectClear) {
      selectClear.onclick = () => {
        select.selectedIndex = 0;
        if (select.value !== '') {
          selectWrap.classList.add('clear');
        } else {
          selectWrap.classList.remove('clear');
        }

        if (
          select.value === '' &&
          select.form.querySelector('.input-css-search input[name="s"]') !== null &&
          select.form.querySelector('.input-css-search input[name="s"]').value === ''
        ) {
          const postTypeInput = select.form.querySelector('input[name="post_type"]');

          if (postTypeInput !== null && postTypeInput.value !== '') {
            if (
              // eslint-disable-next-line no-undef,camelcase
              typeof deepsea_investments_vars !== 'undefined' &&
              // eslint-disable-next-line no-undef,camelcase
              deepsea_investments_vars.siteUrl !== undefined
            ) {
              // eslint-disable-next-line no-undef,camelcase
              window.location.href = `${deepsea_investments_vars.siteUrl}/resources/${postTypeInput.value}/`;
            } else {
              window.location.href = `/insights/`;
            }

            return;
          }
        }

        select.form.submit();
      };
    }
  }
});
